import "./bootstrap";
import "../css/app.css";

import { createApp, h, DefineComponent } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";

const appName = "Prodct";

// Social sharing
import VueSocialSharing from "vue-social-sharing";

import { AntlerPlugin } from "@/Utils/antler-provider";
import { createModalModule } from "@/Utils/modules/modal-module";

createInertiaApp({
    title: title => `${title} - ${appName}`,
    resolve: name =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob<DefineComponent>("./Pages/**/*.vue"),
        ),
    setup({ el, App, props, plugin }) {
        const vm = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueSocialSharing)
            .use(AntlerPlugin, {
                modules: [createModalModule()],
            });

        // Sentry.init({
        //     dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
        // });

        vm.mount(el);
        return vm;
    },
    progress: {
        color: "#4B5563",
    },
});
